import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '../../img/title.png';
import _imports_1 from '../../img/QRCode.png';
const _hoisted_1 = {
  class: "head"
};
const _hoisted_2 = {
  class: "leftbox"
};
const _hoisted_3 = {
  class: "rightbox"
};
const _hoisted_4 = {
  class: "tabber"
};
const _hoisted_5 = ["onClick", "onMouseover"];
const _hoisted_6 = {
  key: 0,
  class: "onePage"
};
const _hoisted_7 = ["onClick"];
import { reactive, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Search } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import { getMessageConfig, articleSearchConfig } from "../../api/home";
export default {
  __name: 'headTabbar',
  setup(__props) {
    const data = reactive({
      title: "",
      index: 0,
      id: "",
      treeSelectList: [],
      input: "",
      pageNum: 1,
      pageSize: 100,
      clickItemBtnIndex: ""
    });
    const route = useRoute();
    const router = useRouter();
    watch(() => router.currentRoute.value, toPath => {
      if (localStorage.getItem("headId")) {
        data.index = localStorage.getItem("headId");
      }
      if (localStorage.getItem("headValueId")) {
        data.id = localStorage.getItem("headValueId");
      }
    }, {
      immediate: true,
      deep: true
    });
    const treeSelect = () => {
      getMessageConfig().then(res => {
        data.treeSelectList = res.data;
      });
    };
    const clickItem = (index, id) => {
      localStorage.setItem("headId", index);
      localStorage.setItem("headValueId", id);
      if (id == '1987831222629982210') {
        router.push({
          path: "/"
        });
      } else if (id == '1988426439470223361') {
        router.push({
          path: "/about"
        });
      } else {
        router.push({
          path: "/medium",
          query: {
            userId: id
          }
        });
      }
    };
    const clickItems = (id, userId) => {
      router.push({
        path: "/medium",
        query: {
          ids: id,
          userId: userId
        }
      });
      data.oneShow = false;
      data.twoShow = false;
      data.threeShow = false;
    };
    const clickItemBtn = (index, id) => {
      data.clickItemBtnIndex = index;
    };
    const SearchBtn = () => {
      if (data.input) {
        articleSearchConfig(data.input, data.pageNum, data.pageSize).then(res => {
          console.log(res, "8888");
          if (res.data.length != 0) {
            router.push({
              path: "/redBook",
              query: {
                name: data.input
              }
            });
          } else {
            ElMessage.warning('请重新输入关键词');
            data.input = "";
          }
        });
      } else {
        ElMessage.warning('请输入关键词');
      }
    };
    onMounted(() => {
      // 代码逻辑0
      treeSelect();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "titile"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_3, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "QRCode"
      }, [_createElementVNode("img", {
        src: _imports_1,
        alt: ""
      }), _createElementVNode("div", {
        class: "name"
      }, "协会官方微信")], -1)), _createVNode(_component_el_input, {
        class: "inputSearch",
        style: {},
        placeholder: "请输入搜索关键词",
        modelValue: data.input,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.input = $event)
      }, {
        prepend: _withCtx(() => [_createVNode(_component_el_button, {
          icon: _unref(Search)
        }, null, 8, ["icon"])]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", {
        class: "Search",
        onClick: SearchBtn
      }, "搜索")])]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.treeSelectList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "one",
          key: index,
          onClick: $event => clickItem(index, item.id),
          onMouseleave: _cache[1] || (_cache[1] = $event => data.clickItemBtnIndex = ''),
          onMouseover: $event => clickItemBtn(index, item.id)
        }, [_createTextVNode(_toDisplayString(item.name) + " ", 1), item.children && data.clickItemBtnIndex == index ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (items, indexs) => {
          return _openBlock(), _createElementBlock("div", {
            class: "oneName",
            key: indexs,
            onClick: _withModifiers($event => clickItems(items.id, item.id), ["stop"])
          }, _toDisplayString(items.name), 9, _hoisted_7);
        }), 128))])) : _createCommentVNode("", true)], 40, _hoisted_5);
      }), 128))])]);
    };
  }
};